<template>
  <div>
    <div class="main" style="margin-top: 5px;">

      <div style="width: 90%;margin-left:2%;height:40px;line-height: 40px;">
       首页>       		<router-link :to="{name:'transferList'}" class="typeNav" >
产权交易</router-link> > {{transferData.itemName}}
      </div>
      <div style="width: 100%; margin-top: 0px;height: auto;overflow: hidden;border：1px solid #ccc;">
        <div style="width: 50%;height:300px;margin-top:20px;float: left;">
          <div style="width: 80%;margin-left: 10%;border: 1px solid #ccc;height: 340px;">
            <el-carousel height="340px" width="100%">
              <el-carousel-item  v-if="transferData.images!=null&&transferData.images!=''" v-for="(item,index) in transferData.images.split(',')" :key="item">
                <img :src="item" style="height: 340px;width:100%">
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>

        <div style="width:42%;height: 380px;float: left;margin-top: 0px;margin-left: 2%;font-size: 14px;">
          <div
            style="width: 100%; font-size: 21px;min-height: 40px;line-height: 30px;text-align: center;border-bottom: 1px solid #ccc;">
            <strong>{{transferData.itemName}}

            </strong>
          </div>
          <div style="width: 100%;height: 40px;line-height: 40px;">
            <div style="width:100%;height: 40px;line-height:40px;float: left;">
              项目编号： {{transferData.itemNum}}
            </div>

          </div>
          <div style="width: 100%;height: 40px;line-height: 40px;">
            <div style="width:100%;height: 40px;line-height:40px;float: left;">
              交易方式：
             <span v-if="transferData.tradeWay==1">自由竞价</span>
              <span v-if="transferData.tradeWay==2">网络竞价（向上竞价）</span>
              <span v-if="transferData.tradeWay==3">拍卖</span>
              <span v-if="transferData.tradeWay==4">招投标</span>
              <span v-if="transferData.tradeWay==5">其他</span>
              <span v-if="transferData.tradeWay==6">招商</span>

            </div>
          </div>
          <div style="width: 100%;height: 40px;line-height: 40px;">
            <div style="width:100%;height: 40px;line-height:40px;float: left;">
              联系电话：
             {{transferData.telNo}}
            </div>
          </div>
         <div style="width: 100%;height: 40px;line-height: 40px;">
            <div style="width:100%;height: 40px;line-height:40px;float: left;">
              流转期限：  {{transferData.circulationPeriod}} 年
            </div>
          </div>
          <div style="width: 100%;height: 40px;line-height: 40px;">
            <div style="width:100%;height: 40px;line-height:40px;float: left;">
              转出方式： <span v-if="transferData.transferWay==1">出租</span>
             <span v-if="transferData.transferWay==2">转让</span>
             <span v-if="transferData.transferWay==3">出售</span>
             <span v-if="transferData.transferWay==4">出让</span>
             <span v-if="transferData.transferWay==5">其他</span>
            </div>
          </div>
          <div style="width: 100%;height: 40px;line-height: 40px;">
            <div style="width:100%;height: 40px;line-height:40px;float: left;">
              所占面积：
             {{transferData.areaNum}}
              <span v-if="transferData.areaUnit==1">亩</span>
              <span v-if="transferData.areaUnit==2">平方米</span>
              <span v-if="transferData.areaUnit==3">公顷</span>
            </div>
          </div>
          <div style="width: 100%;height: 40px;line-height: 40px;">
            <div style="width:100%;height: 40px;line-height:40px;float: left;">
              挂牌价格：
              <span style="color: #4cb050;font-weight: 500;font-size: 16px;">￥{{transferData.price}}

              {{getEnumByCode(transferData.priceType)}}
              </span>
            </div>
          </div>


          <div style="width: 100%;height: 40px;line-height: 40px;">
            <div style="width:100%;height: 40px;line-height:40px;float: left;">
              报名起止时间：
            <span v-if="transferData.signUpStartTime!=null">
            {{transferData.signUpStartTime.substr(0,10)}} — {{transferData.signUpEndTime.substr(0,10)}}
            </span>
            </div>
          </div>


        </div>
      </div>

      <div style="width: 90%;height:80px;margin-left: 5%;border: 1px solid #cccccc52;">
        <div style="width: 10%;height:80px;float:left;background-color: #cccccc52;text-align: center;font-size: 20px;font-weight: bold;">
          <div style="margin-top: 10px;">
            项目<br>
          流程
          </div>
        </div>
        <div style="float: left;height:80px;width: 85%;margin-left: 2%;">
        <img src="../../../assets/trade/tradeProcess.png" style="height: 60px;width:100%;margin-top: 10px;">
        </div>
      </div>

      <div style="width: 90%;height:40px;border-bottom:1px solid  #30c775dd;margin-left: 5%;margin-top: 10px;">
        <!-- <div class="perNav" @click="chnageCurrentNav('基本信息')" :class="{perNavActive : currentNav=='基本信息'}"
          style="border-right:none;">基本信息</div> -->
        <div class="perNav" @click="chnageCurrentNav('交易公告')" :class="{perNavActive : currentNav=='交易公告'}"
          style="border-right:none;">交易公告</div>
        <div class="perNav" @click="chnageCurrentNav('交易须知')" :class="{perNavActive : currentNav=='交易须知'}"
          style="border-right:none;">交易须知</div>
        <div class="perNav" @click="chnageCurrentNav('图片展示')" :class="{perNavActive : currentNav=='图片展示'}">图片展示</div>
      </div>




      <div v-if="currentNav=='交易公告'" >
        <div style="width: 90%;margin-left: 5%;;height: auto;overflow: hidden;" v-html=transferData.announcement>

        </div>
      </div>


      <div v-if="currentNav=='交易须知'" >
        <div style="width: 90%;margin-left: 5%;;height: auto;overflow: hidden;" v-html=transferData.notice>

        </div>
      </div>


      <!--图片展示-->


      <div v-if="currentNav=='图片展示'">
        <img  :src="item"  v-for="(item,index) in transferData.images.split(',')" style="width: 90%;margin-left: 5%;"/>
      </div>




      <div style="width:100%;height:80px;background-color: white;text-align: center;margin-top: 20px;">


        <el-button type="primary" icon="el-icon-thumb" v-if="transferData.state==5&&transferData.tradeWay==2"
          @click="showModal()">报名</el-button>

&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <a :href="item" target="_blank"  v-if="transferData.contract!=''"  v-for="(item,index) in transferData.contract.split(',')">
          <el-button     type="success" icon="el-icon-download" style="margin-left: 2%;"
           >附件{{index+1}}</el-button>
           </a>
      </div>
    </div>




    <el-dialog title="填写基本信息" :visible.sync="signModalFlag" width="80%" :before-close="handleClose" append-to-body>
      <div style="width: 100%;height: 500px;">
        <el-form ref="signUp" :model="signUp" :inline="true" label-width="100px" style="margin-top: 10px;">
          <el-col :span="12">
            <el-form-item label="类型" label-width="150px">
              <el-select v-model="signUp.type" placeholder="请选择" @change="getUserType()">
                <el-option v-for="item in userTypes" :key="item.type" :label="item.name" :value="item.type">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="12" v-if="userType==1">
            <el-form-item label="姓名" label-width="150px">
              <el-input v-model="signUp.name"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="24" v-if="userType==1">

            <el-col :span="12">
              <el-form-item label="联系方式" label-width="150px">
                <el-input v-model="signUp.phone" placeholder="请输入联系方式"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="身份证号" label-width="150px">
                <el-input v-model="signUp.idCard" placeholder="请输入身份证号"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="身份证号正面" label-width="150px">
                <el-upload class="upload-demo"   accept=".jpg,.jpeg,.png" action="http://36.133.43.44:8547/api/web/upload"
                  :on-preview="handlePreview" :on-remove="handleRemove" :before-remove="beforeRemove"
                  :on-success="getCardPositive" multiple :limit="1" :on-exceed="handleExceed"
                  :file-list="fileListCardPositive">
                  <el-button size="small" type="primary">点击上传</el-button>
                  <div slot="tip" class="el-upload__tip">只能上传jpg/jpeg/png文件</div>
                </el-upload>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="身份证号反面" label-width="150px">
                <el-upload class="upload-demo"  accept=".jpg,.jpeg,.png" action="http://36.133.43.44:8547/api/web/upload"
                  :on-preview="handlePreview" :on-remove="handleRemove" :before-remove="beforeRemove"
                  :on-success="getcardReverse" multiple :limit="1" :on-exceed="handleExceed"
                  :file-list="fileListcardReverse">
                  <el-button size="small" type="primary">点击上传</el-button>
                  <div slot="tip" class="el-upload__tip">只能上传jpg/jpeg/png文件</div>
                </el-upload>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="户口薄" label-width="150px">
                <el-upload class="upload-demo"  accept=".jpg,.jpeg,.png" action="http://36.133.43.44:8547/api/web/upload"
                  :on-preview="handlePreview" :on-remove="handleRemove" :before-remove="beforeRemove"
                  :on-success="getHouseholdRegister" multiple :limit="1" :on-exceed="handleExceed"
                  :file-list="fileListHouseholdRegister">
                  <el-button size="small" type="primary">点击上传</el-button>
                  <div slot="tip" class="el-upload__tip">只能上传jpg/jpeg/png文件</div>
                </el-upload>
              </el-form-item>
            </el-col>
          </el-col>

          <el-col :span="12" v-if="userType==2">
            <el-form-item label="负责人姓名" label-width="150px">
              <el-input v-model="signUp.name"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24" v-if="userType==2">

            <el-col :span="12">
              <el-form-item label="联系方式" label-width="150px">
                <el-input v-model="signUp.phone" placeholder="请输入联系方式"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="身份证号" label-width="150px">
                <el-input v-model="signUp.idCard" placeholder="请输入身份证号"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="身份证号正面" label-width="150px">
                <el-upload class="upload-demo"  accept=".jpg,.jpeg,.png" action="http://36.133.43.44:8547/api/web/upload"
                  :on-preview="handlePreview" :on-remove="handleRemove" :before-remove="beforeRemove"
                  :on-success="getCardPositive" multiple :limit="1" :on-exceed="handleExceed"
                  :file-list="fileListCardPositive">
                  <el-button size="small" type="primary">点击上传</el-button>
                  <div slot="tip" class="el-upload__tip">只能上传jpg/jpeg/png文件</div>
                </el-upload>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="身份证号反面" label-width="150px">
                <el-upload class="upload-demo" accept=".jpg,.jpeg,.png" action="http://36.133.43.44:8547/api/web/upload"
                  :on-preview="handlePreview" :on-remove="handleRemove" :before-remove="beforeRemove"
                  :on-success="getcardReverse" multiple :limit="1" :on-exceed="handleExceed"
                  :file-list="fileListcardReverse">
                  <el-button size="small" type="primary">点击上传</el-button>
                  <div slot="tip" class="el-upload__tip">只能上传jpg/jpeg/png文件</div>
                </el-upload>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="机构合法证明" label-width="150px">
                <el-upload class="upload-demo"  accept=".jpg,.jpeg,.png" action="http://36.133.43.44:8547/api/web/upload"
                  :on-preview="handlePreview" :on-remove="handleRemove" :before-remove="beforeRemove"
                  :on-success="getLegalOrganization" multiple :limit="1" :on-exceed="handleExceed"
                  :file-list="fileListLegalOrganization">
                  <el-button size="small" type="primary">点击上传</el-button>
                  <div slot="tip" class="el-upload__tip">只能上传jpg/jpeg/png文件</div>
                </el-upload>
              </el-form-item>
            </el-col>
          </el-col>


          <el-col :span="12" v-if="userType==3">
            <el-form-item label="公司名称" label-width="150px">
              <el-input v-model="signUp.name"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24" v-if="userType==3">

            <el-col :span="12">
              <el-form-item label="联系方式" label-width="150px">
                <el-input v-model="signUp.phone" placeholder="请输入联系方式"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="身份证号" label-width="150px">
                <el-input v-model="signUp.idCard" placeholder="请输入身份证号"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="身份证号正面" label-width="150px">
                <el-upload class="upload-demo" action="http://36.133.43.44:8547/api/web/upload"
                  :on-preview="handlePreview" :on-remove="handleRemove" :before-remove="beforeRemove"
                  :on-success="getCardPositive" accept=".jpg,.jpeg,.png" multiple :limit="1" :on-exceed="handleExceed"
                  :file-list="fileListCardPositive">
                  <el-button size="small" type="primary">点击上传</el-button>
                  <div slot="tip" class="el-upload__tip">只能上传jpg/jpeg/png文件</div>
                </el-upload>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="身份证号反面" label-width="150px">
                <el-upload class="upload-demo"  accept=".jpg,.jpeg,.png"  action="http://36.133.43.44:8547/api/web/upload"
                  :on-preview="handlePreview" :on-remove="handleRemove" :before-remove="beforeRemove"
                  :on-success="getcardReverse" multiple :limit="1" :on-exceed="handleExceed"
                  :file-list="fileListcardReverse">
                  <el-button size="small" type="primary">点击上传</el-button>
                  <div slot="tip" class="el-upload__tip">只能上传jpg/jpeg/png文件</div>
                </el-upload>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="工商营业执照" label-width="150px">
                <el-upload class="upload-demo"  accept=".jpg,.jpeg,.png" action="http://36.133.43.44:8547/api/web/upload"
                  :on-preview="handlePreview" :on-remove="handleRemove" :before-remove="beforeRemove"
                  :on-success="getBusinessLicense" multiple :limit="1" :on-exceed="handleExceed"
                  :file-list="fileBusinessLicense">
                  <el-button size="small" type="primary">点击上传</el-button>
                  <div slot="tip" class="el-upload__tip">只能上传jpg/jpeg/png文件</div>
                </el-upload>
              </el-form-item>
            </el-col>
      <!--      <el-col :span="12">
              <el-form-item label="组织机构代码证" label-width="150px">
                <el-upload class="upload-demo" action="http://36.133.43.44:8547/api/web/upload"
                  :on-preview="handlePreview" :on-remove="handleRemove" :before-remove="beforeRemove"
                  :on-success="getOrganizationCode" multiple :limit="1" :on-exceed="handleExceed"
                  :file-list="fileOrganizationCode">
                  <el-button size="small" type="primary">点击上传</el-button>
                  <div slot="tip" class="el-upload__tip">只能上传jpg/png文件</div>
                </el-upload>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="公司章程证件" label-width="150px">
                <el-upload class="upload-demo" action="http://36.133.43.44:8547/api/web/upload"
                  :on-preview="handlePreview" :on-remove="handleRemove" :before-remove="beforeRemove"
                  :on-success="getBylaw" multiple :limit="1" :on-exceed="handleExceed" :file-list="fileBylaw">
                  <el-button size="small" type="primary">点击上传</el-button>
                  <div slot="tip" class="el-upload__tip">只能上传jpg/png文件</div>
                </el-upload>
              </el-form-item>
            </el-col> -->
          </el-col>



          <el-button type="primary" @click="enroll()" icon="el-icon-check" style="margin-left: 31%;width:300px">提交
          </el-button>

        </el-form>



      </div>
    </el-dialog>

  </div>
</template>

<script>
  export default {
    data() {
      return {
        transferData: {},
        id: "",
        signUp: {
          type: "",
          businessLicense: "",
          bylaw: "",
          cardPositive: "",
          cardReverse: "",
          householdRegister: "",
          idCard: "",
          legalOrganization: "",
          name: "",
          organizationCode: "",
          phone: "",
          transferId: 0,
        },
        signModalFlag: false,
        userTypes: [{
          'type': 1,
          'name': "自然人"
        }, {
          'type': 2,
          'name': "农村集体经济组织"
        }, {
          'type': 3,
          'name': "公司"
        }],
        fileListCardPositive: [],
        fileListcardReverse: [],
        fileListHouseholdRegister: [],
        fileListLegalOrganization: [],
        fileBusinessLicense: [],
        fileOrganizationCode: [],
        fileBylaw: [],
        importHeaders: {
          token: localStorage.getItem('token'),
          // "Content-Type": false,
        },
        userType: 1,
        currentNav: '交易公告',
        emnus:[],

      }
    },
    created() {

      this.getDetails();
      this.id = this.$route.query.id
      this.signUp.transferId = this.$route.query.id;

this.getEmnusByType(2);
    },
    methods: {
      async getEmnusByType(type){
        const action = "/web/queryEnumsByType/"+type;
        const {
          data: res
        } = await this.$http.get(action);
        this.emnus=res.data;
      },

       getEnumByCode(code){

        return this.emnus.find(d => d.code === code).desc;
      },
      async getDetails() {
        const action = "/web/v1/transfer/" + this.$route.query.id;
        const {
          data: res
        } = await this.$http.get(action);
        this.transferData = res.data;
      },
      chnageCurrentNav(nav) {
        this.currentNav = nav;
      },
      getUserType() {
        this.userType = this.signUp.type;
      },
      handleRemove(file, fileList) {
        console.log(file, fileList);
      },
      handlePreview(file) {
        console.log(file);
      },
      handleExceed(files, fileList) {},
      beforeRemove(file, fileList) {
        return this.$confirm(`确定移除 ${ file.name }？`);
      },
      getCardPositive(response, file, fileList) {
        console.log(response)
        this.signUp.cardPositive = response.data;
        this.$message.success("身份证正面上传成功！");
      },
      getcardReverse(response, file, fileList) {
        console.log(response)
        this.signUp.cardReverse = response.data;
        this.$message.success("身份证反面上传成功！");
      },
      getHouseholdRegister(response, file, fileList) {
        console.log(response)
        this.signUp.householdRegister = response.data;
        this.$message.success("户口薄上传成功！");
      },
      getLegalOrganization(response, file, fileList) {
        console.log(response)
        this.signUp.legalOrganization = response.data;
        this.$message.success("机构合法证明上传成功！");
      },
      getBusinessLicense(response, file, fileList) {
        console.log(response)
        this.signUp.businessLicense = response.data;
        this.$message.success("工商营业执照上传成功！");
      },
      getBylaw(response, file, fileList) {
        console.log(response)
        this.signUp.bylaw = response.data;
        this.$message.success("公司章程证件上传成功！");
      },
      getOrganizationCode(response, file, fileList) {
        console.log(response)
        this.signUp.organizationCode = response.data;
        this.$message.success("组织机构代码证上传成功！");
      },


      async showModal() {

        if (localStorage.getItem("token") == "" || localStorage.getItem("token") == null || localStorage.getItem(
            "token") == undefined) {
          this.$message.error("请登录");
          this.$router.push("/");
          const {
            href
          } = this.$router.resolve({
            path: "/login",
            query: {},
          });
          window.open(href, '_blank');

          return;
        } else {
          const action = "/web/verifyToken";
          const {
            data: res
          } = await this.$http.get(action);
          if (res.code == 108) {
            this.$message.error("请登录");
            this.$router.push("/");
            const {
              href
            } = this.$router.resolve({
              path: "/login",
              query: {},
            });
            window.open(href, '_blank');
            return;
          }

          this.signModalFlag = true;
        }
      },
      enroll() {
        if (this.signUp.name == "") {
          this.$message.error("请输入名称");
          return;
        }
        if (this.signUp.idCard == "" || (this.signUp.idCard.length != 15 && this.signUp.idCard.length != 18)) {
          this.$message.error("请输入正确格式的身份证号码");
          return;
        }
        if (this.signUp.phone.length == "" || (this.signUp.phone.length != 11)) {
          this.$message.error("请输入正确格式的手机号码");
          return;
        }

        if (this.signUp.cardPositive == "") {
          this.$message.error("请上传身份证正面");
          return;
        }
        if (this.signUp.cardReverse == "") {
          this.$message.error("请上传身份证反面");
          return;
        }


        this.$http.post("/web/v1/signUp", this.signUp).then((res) => {
          if (res.data.msg == "success") {
            this.$message.success("报名成功,请及时交保证金");
            this.signModalFlag = false;
          } else {
            this.$message.success(res.data.msg)
          }

        });

      },
      handleClose(done) {
        done();
      },


    }



  };
</script>

<style scoped="">
  @import url("../../../assets/css/index.css");
  @import url("../../../assets/css/base.css");
  @import url("../../../assets/css/main.css");
  @import url("../../../assets/css/news.css");


  .perNav {
    width: 100px;
    height: 39px;
    line-height: 39px;
    text-align: center;
    float: left;
    margin-bottom: 10px;
    font-weight: 500;
    font-size: 16px;
    border: 1px solid #d1d1d1;
    border-bottom: none;
    cursor: pointer;
  }

  .perNavActive {
    background-color: #30c775dd;
    border: 1px solid #30c775dd !important;
    color: white;
  }


  .table_lb {
    background: #f6f6f6;
    height: 40px;
    font-size: 20px;
    border-bottom: 2px solid #4cb050;
    width: 100%;

  }

  .el-descriptions__title {
    font-size: 18px !important;
  }

  .per_title {
    width: 99%;
    margin-left: 1%;
    height: 40px;
    line-height: 2.5rem;
    font-size: 20px;
  }

  .per_content {
    width: 100%;
    margin-left: 0%;
    height: 285px;
    border: 1px solid black;
  }

  .per_per {
    width: 100%;
    height: 40px;
    line-height: 40px;
    border-bottom: 1px solid black;
  }

  .per_per_name {
    width: 49%;
    height: 40px;
    float: left;
    padding-left: 10px;
    border-right: 1px solid #ccc;
  }



  .hone-container {
    height: 100%;
  }

  a-layout-content {
    height: 100%;
  }

  .ant-layout-header {
    /* 2850A0 */
    padding: 0px;
    background-color: #3c8dbc !important;
  }

  .main {
    width: 1220px;
    margin: 0 auto;
    height: auto;
    overflow: hidden;
    background-color: white;
    margin-top: 5px;
  }
</style>
